// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"481":"2018dbbb","765":"a1f1250f"}[chunkId] + ".chunk.css";
};